import type { DiamTeamTree } from '../../diamApi';
import { TreeNode } from './types';

export function mapTeamTree(teams: DiamTeamTree[] | undefined): TreeNode[] {
  return (teams ?? []).map(team => {
    const children = mapTeamTree(team.children);

    return {
      id: team.id,
      label: team.name,
      ...(children.length > 0 ? { children } : {}),
    };
  });
}
